import { forwardRef } from "react";

import PropTypes from "prop-types";

import CheckIcon from "@/icons/CheckIcon";
import sentenceCase from "@/utils/sentenceCase";
import {
  checkIconContainerCss,
  checkIconCss,
  inputCss,
  labelCss,
  radioContainerCss,
} from "./ColorPickerRadioButton.style";

const propTypes = {
  color: PropTypes.shape({
    penName: PropTypes.string,
    label: PropTypes.string,
  }),
  handleOnChange: PropTypes.func,
  isSelected: PropTypes.bool,
};

const ColorPickerRadioButton = forwardRef(
  ({ color, handleOnChange, isSelected }, ref) => {
    return (
      <div css={radioContainerCss(color.label, isSelected)}>
        <input
          type="radio"
          css={inputCss}
          id={color.penName}
          value={color.penName}
          checked={isSelected}
          aria-checked={isSelected}
          name="penName"
          onChange={handleOnChange}
          ref={ref}
        />
        <span aria-hidden={!isSelected} css={checkIconContainerCss}>
          {isSelected && <CheckIcon css={checkIconCss(color.label)} />}
        </span>
        <label htmlFor={color.penName} css={labelCss(isSelected)}>
          <span>{sentenceCase(color.label)}</span>
        </label>
      </div>
    );
  },
);

ColorPickerRadioButton.propTypes = propTypes;

export default ColorPickerRadioButton;
